/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "PartialPaymentReportService";
const log: any = LoggerModule.getInstance();

export class PartialPaymentReportService {
  private static instance: PartialPaymentReportService;
  private criteria: any;

  private constructor(props: any = {}) { }
  public static getInstance(props: any = {}): PartialPaymentReportService {
    if (!PartialPaymentReportService.instance) {
      PartialPaymentReportService.instance = new PartialPaymentReportService(
        props
      );
    }
    return PartialPaymentReportService.instance;
  }
  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async sendRemainder(args: any) {
    console.log(args);
    const agent = getAgent();
    return agent.sendRemainder(args);
  }
  public async getPartialPaymentUsers(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    if (args) {
      this.setCriteria(args);
    }
    compProps = await agent?.getPartialPaymentUsers(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async deleteBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.deleteBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async processResaleActiveBox(args: any) {
    const agent = getAgent();
    return await agent.resaleActiveBox(args);
  }
}
